<template>
	<div class="tab-pane" id="email">
		<h3 class="info-text mb-0">Email Details</h3>
		<p class="text-center text-secondary mb-4">
			<em>Details about email accounts</em>
		</p>
		<div class="row justify-content-center">
			<div class="col-12 pr-5 pl-5">
				<div class="row">
					<div class="col-12">
						<div class="form-group">
							<div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : useEmailOnDomain, 'bootstrap-switch-off bootstrap-switch-focused' : !useEmailOnDomain }">
								<div class="bootstrap-switch-container" @click="useEmailOnDomain = !useEmailOnDomain">
									<span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
									<span class="bootstrap-switch-label"></span>
									<span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
								</div>
							</div>
							<label for="haveSSH" class="ml-2" style="font-size: 14px;">
								Do you require email service through BigScoots? if you select No, your email service
								will remain with who it is now if you have one.
							</label>
						</div>
						<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
							<div class="form-group col-md-12" style="padding-left: 0" v-if="useEmailOnDomain && isDomainIsInAccount">
								<label style="font-size: 14px; font-weight: bold">In order to maintain seamless communication throughout the migration, please ensure you provide an alternative email address that is not associated with a domain included in this migration or a free email (i.e. Gmail, Yahoo, etc.).</label>
								<input class="form-control" type="text" placeholder="Alternate Email..." v-model="alternateEmail" />
							</div>
						</transition>
						<!--
						<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
							<div class="form-group" v-if="useEmailOnDomain">
								<div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : haveGsuite, 'bootstrap-switch-off bootstrap-switch-focused' : !haveGsuite }">
									<div class="bootstrap-switch-container" @click="haveGsuite = !haveGsuite">
										<span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
										<span class="bootstrap-switch-label"></span>
										<span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
									</div>
								</div>
								<label for="haveSSH" class="ml-2" style="font-size: 14px;">
									If you use GSuite, Office365, Zoho Mail or another third party email service, do you intend on keeping it?
								</label>
							</div>
						</transition>
						<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
							<div class="form-group" v-if="!haveGsuite && useEmailOnDomain">
								<div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : moveEmailToBigscoots, 'bootstrap-switch-off bootstrap-switch-focused' : !moveEmailToBigscoots }">
									<div class="bootstrap-switch-container" @click="moveEmailToBigscoots = !moveEmailToBigscoots">
										<span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
										<span class="bootstrap-switch-label"></span>
										<span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
									</div>
								</div>
								<label for="haveSSH" class="ml-2" style="font-size: 14px;">
									Would you like BigScoots to provide you with email service?
								</label>
							</div>
						</transition>
						<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
							<div class="form-group" v-if="!haveGsuite && useEmailOnDomain">
								<label for="emailSpecialRequest" style="font-size: 14px;">Please enter any details or special requests you may have for your email with us</label>
								<textarea class="form-control" rows="5" v-model="emailSpecialRequest"></textarea>
							</div>
						</transition>
						-->
						<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
							<!--v-if="!haveGsuite && useEmailOnDomain"-->
							<div class="important-note mt-5">
								<span class="badge bg-violate mb-0">Important</span> Please note, we cannot migrate
								email history, however you will have the option of setting up new email accounts with
								us. If you wish to migrate your email history, please <a
									href="https://help.bigscoots.com/useful-tools-and-tips/sync-email-folders-after-a-move-to-the-new-email-provider"
									target="_blank">see here <i class="fa fa-external-link" aria-hidden="true"></i></a>
								for a how-to guide on doing it yourself.
							</div>
						</transition>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import swal from "sweetalert2"

	export default {
		name: "EmailDetails",
		computed: {
			useEmailOnDomain: {
				get() {
					return this.$store.getters["migration/useEmailOnDomain"]
				},
				set(newState) {
					this.$store.commit("migration/useEmailOnDomainMutate", {state: newState})
				}
			},
			alternateEmail: {
				get() {
					return this.$store.getters["migration/alternateEmail"]
				},
				set(newState) {
					this.$store.commit("migration/mutateAlternateEmail", newState)
				}
			},
			haveGsuite: {
				get() {
					return this.$store.getters["migration/haveGsuite"]
				},
				set(newState) {
					this.$store.commit("migration/haveGsuiteMutate", {state: newState})
				}
			},
			moveEmailToBigscoots: {
				get() {
					return this.$store.getters["migration/moveEmailToBigscoots"]
				},
				set(newState) {
					this.$store.commit("migration/moveEmailToBigscootsMutate", {state: newState})
				}
			},
			emailSpecialRequest: {
				get() {
					return this.$store.getters["migration/emailSpecialRequest"]
				},
				set(newData) {
					this.$store.commit("migration/emailSpecialRequestMutate", {request: newData})
				}
			},
			isDomainIsInAccount () {
				const migrationList = this.$store.getters["migration/migrationList"];
				const user = this.$store.getters.user;
				let isDomainExistInEmail = false;
				migrationList.forEach(migration => {
					if (user.email.toLowerCase().includes(migration.domain.toLowerCase())) {
						isDomainExistInEmail = true
					}
				});
				return isDomainExistInEmail;
			}
		},
		watch : {
			useEmailOnDomain (value) { //show alert on switch
				if (value) {
					swal({
					title: "FYI!",
					text:
						"We do not migrate your email accounts during the migration. Please make sure to create the email accounts and if needed use the Migrate button to sync your emails from the old provider.",
					});
					}
				}
			}
	}
</script>
